<template>
  <!-- 物流安全 -->
  <div class="logisticssafety">
    <div>
      <el-button @click="addRow" size="small" type="success" icon="el-icon-plus">添加物流安全</el-button>
      <el-button size="small" @click="save" type="primary">保存设置</el-button>
    </div>
    <div v-for="(item,i) in tableData" :key='i' class="save_box">
      <el-row :gutter="15">
        <el-col :span="5">
          <div>
            <h4 class="trend-title1">车辆信息</h4>
            <el-form class="bginput" label-width="6rem">
              <el-form-item label="车辆类型">
                <el-input v-model="item.carType" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="品牌型号">
                <el-input v-model="item.carBand" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="车牌号">
                <el-input v-model="item.carModel" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="载重/人量">
                <el-input   v-model="item.carCarry" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="购买日期">
                <el-date-picker v-model="item.payTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="date" placeholder="选择日期时间"> </el-date-picker>
              </el-form-item>
              <el-form-item label="年检状态">
                <el-select v-model="item.carInspect" placeholder="请选择">
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="不正常" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="保险状态">
                <el-input v-model="item.carInsure" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="当前里程">
                <el-input  type="number" oninput="if(value.length > 6) value=value.slice(0, 6)" v-model="item.carMileage" placeholder="请录入">
                  <template slot="suffix">KM</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="5">
          <div>
            <h4 class="trend-title1">运输信息</h4>
            <el-form class="bginput" label-width="6rem">
              <el-form-item label="起始地址">
                <el-input v-model="item.trafficStart" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="目标地址">
                <el-input v-model="item.trafficEnd" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="出发时间">
                <el-date-picker v-model="item.trafficDepart" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="datetime" placeholder="选择日期时间"> </el-date-picker>
              </el-form-item>
              <el-form-item label="预计到达">
                <el-date-picker v-model="item.trafficArrive" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="datetime" placeholder="选择日期时间"> </el-date-picker>
              </el-form-item>
              <el-form-item label="客户名称">
                <el-input v-model="item.trafficCustom" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="业务联系人">
                <el-input v-model="item.trafficLink" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="订单号">
                <el-input v-model="item.trafficOrder" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="应交货日期">
                <el-date-picker v-model="item.trafficDelivery" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="date" placeholder="选择日期时间"> </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="5">
          <div>
            <h4 class="trend-title1">驾驶员信息</h4>
            <el-form class="bginput" label-width="7rem">
              <el-form-item label="驾驶员">
                <el-input v-model="item.driverName" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="年龄">
                <el-input  type="number" oninput="if(value.length > 2) value=value.slice(0, 2)" v-model="item.driverDrivingAge" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="item.driverPhone" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人">
                <el-input v-model="item.driverUrgentName" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系电话">
                <el-input v-model="item.driverUrgentPhone" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="驾驶执照">
                <el-input v-model="item.driverLicense" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="驾驶年龄">
                <el-input  type="number" oninput="if(value.length > 2) value=value.slice(0, 2)" v-model="item.driverAge" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="本年违章扣分">
                <el-input  type="number" oninput="if(value.length > 2) value=value.slice(0, 2)" v-model="item.driverViolation" placeholder="请录入"></el-input>
              </el-form-item>

            </el-form>
          </div>
        </el-col>
        <el-col :span="5">
          <div>
            <h4 class="trend-title1">异常事件</h4>
            <el-form class="bginput" label-width="6rem">
              <el-form-item label="事件">
                <el-input v-model="item.eventType" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="位置">
                <el-input v-model="item.eventAddress" placeholder="请录入"></el-input>
              </el-form-item>
              <el-form-item label="时间">
                <el-date-picker v-model="item.eventTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" type="datetime" placeholder="选择日期时间"> </el-date-picker>
              </el-form-item>
              <el-form-item label="信息">
                <el-input type="textarea" :rows="9" v-model="item.eventInfo" placeholder="请录入"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="1">

          <!-- <i @click="addRow" class="el-icon-circle-plus-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #00ffff;font-weight: 600;cursor: pointer;"></i> -->
          <i @click="del(item,i)" class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>

        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form class="bginput" label-width="6rem">
            <el-form-item label="现场视频">
              <el-input v-model="item.liveVideo" placeholder="请录入mp4地址"></el-input>
            </el-form-item>
            <el-form-item label="回放视频">
              <el-input v-model="item.backVideo" placeholder="请录入mp4地址"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

    </div>

    <!-- <div style="margin-top: 2rem;">
      
    </div> -->

  </div>
</template>

<script>
import api from '@/apis/transportation/logisticssafety'
export default {
  components: {},
  data() {
    return {
      tableData: [
        {
          backVideo: '', //回放视频
          carBand: '', //车辆品牌
          carCarry: '', //载重/人量
          carInspect: 1, //年检状态 1正常 2不正常
          carInsure: '', //保险状态
          carMileage: '', //当前里程
          carModel: '', //车辆型号
          carType: '', //车辆类型
          driverAge: '', //驾驶员年龄
          driverDrivingAge: '', //驾驶年龄
          driverLicense: '', //驾驶执照
          driverName: '', //驾驶员
          driverPhone: '', //驾驶员电话
          driverUrgentName: '', //紧急联系人
          driverUrgentPhone: '', //紧急联系人电话
          driverViolation: '', //本年度违章扣分
          eventAddress: '', //位置
          eventInfo: '', //信息
          eventTime: '', //时间
          eventType: '', //事件
          liveVideo: '', //现场视频
          payTime: '', //购买日期
          trafficArrive: '', //预计到达
          trafficCustom: '', //客户名称
          trafficDelivery: '', //应交货日期
          trafficDepart: '', //出发时间
          trafficEnd: '', //目标地址
          trafficLink: '', //业务联系人
          trafficOrder: '', //订单号
          trafficStart: '', //起始地址
        },
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist(){
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {
              this.tableData = res.data.list
            }
          } else {
            this.$message.error(res.message)
          }
        })      
    },
    addRow() {
      this.tableData.unshift({
        backVideo: '', //回放视频
        carBand: '', //车辆品牌
        carCarry: '', //载重/人量
        carInspect: '', //年检状态 1正常 2不正常
        carInsure: '', //保险状态
        carMileage: '', //当前里程
        carModel: '', //车辆型号
        carType: '', //车辆类型
        driverAge: '', //驾驶员年龄
        driverDrivingAge: '', //驾驶年龄
        driverLicense: '', //驾驶执照
        driverName: '', //驾驶员
        driverPhone: '', //驾驶员电话
        driverUrgentName: '', //紧急联系人
        driverUrgentPhone: '', //紧急联系人电话
        driverViolation: '', //本年度违章扣分
        eventAddress: '', //位置
        eventInfo: '', //信息
        eventTime: '', //时间
        eventType: '', //事件
        liveVideo: '', //现场视频
        payTime: '', //购买日期
        trafficArrive: '', //预计到达
        trafficCustom: '', //客户名称
        trafficDelivery: '', //应交货日期
        trafficDepart: '', //出发时间
        trafficEnd: '', //目标地址
        trafficLink: '', //业务联系人
        trafficOrder: '', //订单号
        trafficStart: '', //起始地址
      })
    },
    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.getlist()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
              this.getlist()
            } else {
              this.$message.error(res.message)
            }
            
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.logisticssafety { width: auto; padding-top: 10px;
  .trend-title1{ position: relative; font-weight: bold; color: #24ffb1; font-size: .9rem; padding-left: 10px; border-left: #24ffb1 solid 5px; display: inline-block; margin: .6rem 0 15px;}
  .el-form-item {
    margin-bottom: 0;
  }
  .save_box{ border: #3570ff solid 1px; width: 95%; padding:.4rem 0 1rem 1rem; margin-top: 1rem;}
}
</style>